import { render, staticRenderFns } from "./FullContactsBlock.vue?vue&type=template&id=570b8452&scoped=true&"
import script from "./FullContactsBlock.vue?vue&type=script&lang=js&"
export * from "./FullContactsBlock.vue?vue&type=script&lang=js&"
import style0 from "./FullContactsBlock.vue?vue&type=style&index=0&id=570b8452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b8452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570b8452')) {
      api.createRecord('570b8452', component.options)
    } else {
      api.reload('570b8452', component.options)
    }
    module.hot.accept("./FullContactsBlock.vue?vue&type=template&id=570b8452&scoped=true&", function () {
      api.rerender('570b8452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/FullContactsBlock.vue"
export default component.exports